import styled from "styled-components";

export const List = styled.ul`
    display: block;
    clear: both;
    overflow: auto;
    width: 100% !important;
    padding: 0;
    li {
        border-bottom: 1px solid rgba(${props => props.theme.secondary}, 0.25);
    }
    span {
        float: right;
    }
    div {
        p {
            font-size: 1.14em !important;
        }
    }
    ul {
        li {
            font-size: 1rem;
            text-align: left;
        }
    }
`;
